import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kw-social-nav',
  templateUrl: './social-nav.component.html',
  styleUrls: ['./social-nav.component.scss']
})
export class SocialNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
